import React, { useCallback } from 'react';
import { MenuList, Paper, TextField } from '@mui/material';

import { closeCurrentPopup, Dialog } from '@paragon/popup-state';

import { useAppDispatch } from '../hooks';
import { InsertableObjectMenuItems } from '../misc/menus/add-items/InsertableObjectMenuItems';
import { useInsertableObjectsMenuInternals as useInsertableObjectsMenu } from '../misc/menus/add-items/useInsertableObjectsMenu';

const MONITOR_TEXT = 'Ctrl+Q';

export function InsertionMenuDialog() {
  const dispatch = useAppDispatch();
  const onChooseItem = useCallback(() => void dispatch(closeCurrentPopup()), [dispatch]);
  const { insertableObjects, insert, handleHotCharacterKeyDown } = useInsertableObjectsMenu(MONITOR_TEXT, onChooseItem);

  return (
    <Dialog variant="design">
      <TextField
        autoFocus
        fullWidth
        autoComplete="off"
        variant="standard"
        label="Insert what?"
        sx={{ marginBottom: 2 }}
        onKeyDown={handleHotCharacterKeyDown}
      />

      <Paper>
        <MenuList>
          <InsertableObjectMenuItems
            monitorText={MONITOR_TEXT}
            onChooseItem={onChooseItem}
            insert={insert}
            insertableObjects={insertableObjects}
          />
        </MenuList>
      </Paper>
    </Dialog>
  );
}
